import { Component, input } from '@angular/core';

@Component({
  selector: 'app-field-loader',
  styles: `
    .loader-wrapper {
      margin-inline-end: 1rem;
      pointer-events: none;
    }
    .field-loader:has(select) .loader-wrapper {
      margin-inline-end: 2.5rem;
    }
  `,
  template: `
    <div class="field-loader position-relative">
      <ng-content />
      @if (loading()) {
        <div class="loader-wrapper position-absolute top-0 bottom-0 end-0 d-flex align-items-center">
          <div class="spinner-border spinner-border-sm text-secondary" role="status">
            <span class="visually-hidden">Caricamento...</span>
          </div>
        </div>
      }
    </div>
  `,
})
export class FieldLoaderComponent {
  loading = input(false);
}